import { Box, IconButton } from '@mui/material'
import React from 'react'
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { gridTableActionCellSx } from "../../utils/facilityColumn";

const MenuIcon = ({handleMenuClick, field, sx = {}}) => {
  return (
    <Box
    sx={{
      ...gridTableActionCellSx,
      ...sx,
    }}
  >
    <IconButton onClick={(e) => handleMenuClick(e, field)}>
      <MoreHorizIcon sx={{ fontWeight: "bold", color: "black" }} />
    </IconButton>
  </Box>
  )
}

export default MenuIcon